import React, { Component }  from 'react';
import { Button, Grid, DialogContentText, Dialog, DialogActions, DialogContent, TextField, DialogTitle } from '@material-ui/core';
import { useTranslation, Trans } from 'react-i18next';
const { t } = useTranslation();

class ScanModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            partNumber: ""
        }
        this.handleChangePartNumber = this.handleChangePartNumber.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.visible !== this.props.visible) {
            this.setState({ partNumber: ""});
        }
      }

    handleChangePartNumber(event) {
        this.setState({ partNumber: event.target.value});
    }

    enterPressed(event) {
        var code = event.keyCode || event.which;
        if(code === 13) { 
            this.props.handleCloseScanDialog(this.state.partNumber)
        } 
    }

    render() {
        return <Dialog open={this.props.visible} onClose={this.handleCloseScanDialog} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title"><Trans>{t('ScanTitle')}</Trans></DialogTitle>
        <DialogContent>
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Trans>{t('MachineSettingsScanned')}</Trans>
                <div className="spacer15"></div>
            </Grid>
            <Grid item xs={3}>
                <DialogContentText>
                    <Trans>{t('Part')}</Trans>
                </DialogContentText>
                </Grid>
                <Grid item xs={9}>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        type="text"
                        value={this.state.partNumber}
                        onChange={this.handleChangePartNumber}
                        onKeyPress={this.enterPressed.bind(this)}
                        fullWidth
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button variant="contained" color="secondary" onClick={() => this.props.handleCloseScanDialog(this.state.partNumber)}>
                <Trans>{t('Ok')}</Trans>
            </Button>
            <Button variant="contained" color="secondary" onClick={this.props.handleScanModalCancel}>
                <Trans>{t('Cancel')}</Trans>
            </Button>
        </DialogActions>
    </Dialog>
    }
}

export default ScanModal;